import React, { useEffect } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import QuickSearchBar from "@/components/site/QuickSearchBar";
import Services from "@/components/site/Services";
import Fleet from "@/components/site/Fleet";
import Destinations from "@/components/site/Destinations";
import Trust from "@/components/site/Trust";
import BookingSection from "@/components/site/BookingSection";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const HomePage = () => {
  useEffect(() => {
    if (!window.location.hash) return;
    const targetId = window.location.hash.replace("#", "");
    const timer = setTimeout(() => {
      const el = document.getElementById(targetId);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div data-testid="home-page" className="bg-[#F9F6F0]">
      <Header />
      <Hero />
      <QuickSearchBar />
      <Services />
      <Fleet />
      <Destinations />
      <Trust />
      <BookingSection />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
